import { render, staticRenderFns } from "./LettersTestAnswerOption.vue?vue&type=template&id=d395ade4&scoped=true"
import script from "./LettersTestAnswerOption.vue?vue&type=script&lang=ts"
export * from "./LettersTestAnswerOption.vue?vue&type=script&lang=ts"
import style0 from "./LettersTestAnswerOption.vue?vue&type=style&index=0&id=d395ade4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d395ade4",
  null
  
)

export default component.exports